import 'common/css/app.css'
import './index.css'
import 'common/js/global.js'

$(function(){
  wayPoint()
})

function wayPoint() {
  $('.page').waypoint(function (direction) {
      if (direction === 'down') {
          $(this.element).find('.state').addClass('animated slideInUp');
      }
  }, {offset: '70%'});
}



// WEBPACK FOOTER //
// ./src/partner/index.js